import {
  basePath,
  certIVAPath,
  certICAPath,
  certRentaPath,
  certPDFPath,
  newBack,
} from "./config";
import axios from "axios";

export function getSuppliersApi(token) {
  const url = `${basePath}/supplierpr/getall`;

  const params = {
    method: "GET",
    //body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}



export function getSuppliersUserApi(token, id) {
  const url = `${basePath}/supplierpr/getalluser?id=${id}`;

  const params = {
    method: "GET",
    //body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };
  return fetch(url, params)
    .then((response) => {
      console.log("result")
      console.log(response)
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function findSuppliersApi(token, find) {
  const url = `${basePath}/supplierpr/findall?f=${find}`;

  const params = {
    method: "GET",
    //body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function getSupplierApi(token, id) {
  const url = `${basePath}/supplierpr/getsupplier?id=${id}`;

  const params = {
    method: "GET",
    //body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return fetch(url, params)
    .then((response) => {
      console.log("resultado")
      console.log(response.resultado.json())
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function getPagosApi(token, id) {
  const url = `${basePath}/supplierpr/getsupplier?id=${id}`;

  const params = {
    method: "GET",
    //body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}


export function uploadTemplateApiIVA(token, fileList) {
  const url = `${basePath}/supplierpr/uploadtemplateiva`;

  const bodyFormData = new FormData();
  bodyFormData.append("file", fileList[0]);

  return axios({
    method: "POST",
    url: url,
    data: bodyFormData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: token,
    },
  })
    .then((response) => {
      return response.data;
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function downloadTemplateApiIVA() {
  const url = `${certIVAPath}/Plantilla_cargue_retencion_IVA.xlsx`;
  return axios({
    method: "get",
    url: url,
    responseType: "arraybuffer",
  })
    .then((response) => {
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/octet-stream" })
      );
      link.download = "Plantilla_cargue_retencion_IVA.xlsx";

      document.body.appendChild(link);

      link.click();
      setTimeout(function () {
        window.URL.revokeObjectURL(link);
      }, 200);
      return "OK";
    })
    .catch((error) => {
      return "ERROR";
    });
}

export function uploadTemplateApiICA(token, fileList) {
  const url = `${newBack}/api/cargaIca`;

  const bodyFormData = new FormData();
  bodyFormData.append("file", fileList[0]);

  return axios({
    method: "POST",
    url: url,
    data: bodyFormData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: token,
    },
  })
    .then((response) => {
      return response.data;
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function downloadTemplateApiICA() {
  const url = `${certICAPath}/Plantilla_cargue_retencion_ICA.xlsx`;
  return axios({
    method: "get",
    url: url,
    responseType: "arraybuffer",
  })
    .then((response) => {
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/octet-stream" })
      );
      link.download = "Plantilla_cargue_retencion_ICA.xlsx";

      document.body.appendChild(link);

      link.click();
      setTimeout(function () {
        window.URL.revokeObjectURL(link);
      }, 200);
      return "OK";
    })
    .catch((error) => {
      return "ERROR";
    });
}

export function generateCertificateIVAApi(token, id, from, to) {
  const url = `${basePath}/supplierpr/generatecertificate`;

  const data = { id: id, from: from, to: to };

  const params = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function generateCertificateICAApi(token, id, from, to) {
  const url = `${basePath}/supplierpr/generatecertificateica`;

  const data = { id: id, from: from, to: to };

  const params = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function uploadTemplateApiFuente(token, fileList, dateValue) {
  const url = `${newBack}/api/cargaFuente`;

  var event = new Date(dateValue);

  let date = JSON.stringify(event);
  date = date.slice(1, 11);

  const bodyFormData = new FormData();
  bodyFormData.append("file", fileList[0]);
  bodyFormData.append("datevalue", date);

  return axios({
    method: "POST",
    url: url,
    data: bodyFormData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: token,
    },
  })
    .then((response) => {
      return response.data;
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function downloadTemplateApiFuente() {
  const url = `${certRentaPath}/Plantilla_cargue_retencion_renta.xlsx`;
  return axios({
    method: "get",
    url: url,
    responseType: "arraybuffer",
  })
    .then((response) => {
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/octet-stream" })
      );
      link.download = "Plantilla_cargue_retencion_renta.xlsx";

      document.body.appendChild(link);

      link.click();
      setTimeout(function () {
        window.URL.revokeObjectURL(link);
      }, 200);
      return "OK";
    })
    .catch((error) => {
      return "ERROR";
    });
}

export function generateCertificateFuenteApi(token, id, anio) {
  const url = `${basePath}/supplierpr/generatecertificatefuente`;

  const data = { id: id, anio: anio };

  const params = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function getAniosCertificate(token) {
  const url = `${basePath}/supplierpr/getaniofuente`;

  //const data = { id: id, from: from, to: to };

  const params = {
    method: "POST",
    //body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function generateReportCertificateApi(
  token,
  fechainicio,
  fechafin,
  type,
  doc
) {
  const url = `${basePath}/supplierpr/generatereportcertificate`;

  const data = {
    fechainicio: fechainicio,
    fechafin: fechafin,
    type: type,
    doc: doc,
  };

  const params = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function downloadReportCertificate(doc) {
  const url = `${certPDFPath}/${doc}`;
  return axios({
    method: "get",
    url: url,
    responseType: "arraybuffer",
  })
    .then((response) => {
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/octet-stream" })
      );
      link.download = `${doc}`;

      document.body.appendChild(link);

      link.click();
      setTimeout(function () {
        window.URL.revokeObjectURL(link);
      }, 200);
      return "OK";
    })
    .catch((error) => {
      return "ERROR";
    });
}

